module.exports = __webpack_public_path__ + "static/media/mobile_download_phone.8745b0ae.png";